(function () {
  angular.module("akitabox.ui.dialogs.workOrderLog.delete", [
    "akitabox.core.constants",
    "akitabox.core.services.workOrderLog",
    "akitabox.core.toast",
  ]);
})();
